const API = '/api';

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...init,
  });
  const json = (await res.json().catch(() => ({}))) as {
    error?: string;
  } & Record<string, unknown>;
  if (!res.ok) {
    throw new Error(json.error || `Request failed: ${res.status}`);
  }
  return json as T;
}

export type User = {
  id: number;
  email: string | null;
  createdAt: string;
};

export const api = {
  me: () => request<{ user: User | null }>('/auth/me'),

  requestOtp: (email: string) =>
    request<{ ok: true; expiresAt: string }>('/auth/request-otp', {
      method: 'POST',
      body: JSON.stringify({ email }),
    }),

  verifyOtp: (email: string, code: string) =>
    request<{ ok: true; user: User }>('/auth/verify-otp', {
      method: 'POST',
      body: JSON.stringify({ email, code }),
    }),

  logout: () =>
    request<{ ok: true }>('/auth/logout', { method: 'POST' }),
};
